import { Route, Routes, useLocation } from "react-router-dom";
import Employee from "./Employee";
import Home from "./Home";
import PersonalEmployee from "./PersonalEmployee";
import Department from "./Department";
import Payrollpage from "./Payrollpage";
import Navbar from "./Navbar";
import PatrollPersonal from "./PatrollPersonal";
import Crud from "./Crud";
import Modify from "./Modify";
function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route exact path="/emp" element={<Employee />} />
        <Route exact path="/personal" element={<PersonalEmployee />} />
        <Route exact path="/dept" element={<Department />} />
        <Route exact path="/payroll" element={<Payrollpage />} />
        <Route exact path="/crud" element={<Crud />} />
        <Route exact path="/modify" element={<Modify />} />
        <Route exact path="/payroll/:empid" element={<PatrollPersonal />} />
      </Routes>
    </>
  );
}

export default App;
